import type { ComponentProps } from 'react';
import type { ListToolbar } from '@forecastify/ui';
import type { useT } from '../../i18n';
import { listLabels } from '../delivery/clients-screen';
import type { DealModeProps } from './deals-modes';

/**
 * The toolbar every non-list mode of `/deals` opens with: the mode switch and, for somebody who
 * may, the primary *Új deal* — the same pair the list's `DataList` draws itself. A mode adds its
 * own search, filters or trailing control on top.
 */
export function dealModeToolbar(
  t: ReturnType<typeof useT>,
  { modeSwitch, canManage, onCreate }: DealModeProps,
): ComponentProps<typeof ListToolbar> {
  return {
    viewSwitch: modeSwitch,
    actions: canManage
      ? [{ label: t('deals.action.create'), icon: 'plus', primary: true, onSelect: onCreate }]
      : [],
    labels: listLabels(t),
  };
}
